import { useDateLocale, useTimeZone } from '../../../../../hooks'

import { getCalendarGridNowStyle } from './CalendarGridWeekNowLine.utils'

import * as styles from './CalendarGridWeekNowLine.module.css'

function CalendarGridWeekNowLine({ firstHour, now }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <div
      className={styles.CalendarGridWeekNowLine}
      style={getCalendarGridNowStyle({ firstHour, locale, now, timezone })}
    />
  )
}

export default CalendarGridWeekNowLine
